(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sbl-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sbl-home]');
    roots.forEach((root) => {
      if (root.dataset.sblReady === 'true') return;
      root.dataset.sblReady = 'true';
      const rotator = root.querySelector('[data-sbl-rotator-label]');
      const toggle = root.querySelector('[data-sbl-rotator]');
      const menu = root.querySelector('[data-sbl-menu]');
      const cardWord = root.querySelector('[data-sbl-card-word]');
      const links = Array.from(root.querySelectorAll('[data-sbl-slide-link]'));
      const slides = Array.from(root.querySelectorAll('[data-sbl-slide]'));
      const card = root.querySelector('.sbl-home__designer-card');
      if (!rotator || links.length === 0) return;

      let index = 0;
      let paused = false;
      let menuOpen = false;
      const setMenu = (open) => {
        menuOpen = open;
        paused = open;
        if (!menu || !toggle) return;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      const show = (next) => {
        index = next;
        const word = links[index].textContent.trim();
        rotator.textContent = word;
        if (cardWord) cardWord.textContent = word;
        links.forEach((link, i) => link.setAttribute('aria-current', i === index ? 'true' : 'false'));
        slides.forEach((slide) => {
          slide.dataset.active = String(Number(slide.dataset.sblSlide) === index);
        });
      };
      show(0);

      if (toggle && menu) {
        toggle.addEventListener('click', () => setMenu(!menuOpen));
        const close = root.querySelector('[data-sbl-menu-close]');
        if (close) close.addEventListener('click', () => setMenu(false));
        document.addEventListener('click', (event) => {
          if (menuOpen && !root.querySelector('.sbl-home__picker').contains(event.target)) setMenu(false);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menuOpen) setMenu(false);
        });
        menu.addEventListener('mouseenter', () => { paused = true; });
        menu.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
      }

      links.forEach((link, i) => {
        link.addEventListener('mouseenter', () => { paused = true; show(i); });
        link.addEventListener('focus', () => { paused = true; show(i); });
        link.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
        link.addEventListener('blur', () => { if (!menuOpen) paused = false; });
      });
      if (card) {
        card.addEventListener('mouseenter', () => { paused = true; });
        card.addEventListener('mouseleave', () => { if (!menuOpen) paused = false; });
      }

      if (links.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.setInterval(() => {
        if (!paused) show((index + 1) % links.length);
      }, 2800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbl-industries"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-sbl-industries]');
    if (!root || root.dataset.sblReady === 'true') return;
    root.dataset.sblReady = 'true';
    root.classList.add('is-enhanced');
    const links = Array.from(root.querySelectorAll('[data-sbl-industry]'));
    const panels = Array.from(root.querySelectorAll('[data-sbl-panel]'));
    const showAll = root.querySelector('[data-sbl-show-all]');
    const aliases = { universities: 'schools', warehouses: 'offices', government: 'offices' };
    const resolve = (id) => aliases[id] || id;
    const show = (id, scroll) => {
      id = resolve(id);
      const match = Boolean(id) && panels.some((panel) => panel.dataset.sblPanel === id);
      root.classList.toggle('has-selection', match);
      panels.forEach((panel) => panel.classList.toggle('is-active', match && panel.dataset.sblPanel === id));
      links.forEach((link) => link.classList.toggle('is-current', match && link.dataset.sblIndustry === id));
      if (scroll && match) {
        const panel = root.querySelector('[data-sbl-panel="' + id + '"]');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    const jumpLinks = Array.from(root.querySelectorAll('[data-sbl-industry], [data-sbl-industry-link]'));
    jumpLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const id = link.dataset.sblIndustry || link.dataset.sblIndustryLink;
        history.replaceState(null, '', '#' + id);
        show(id, true);
      });
    });
    if (showAll) {
      showAll.addEventListener('click', () => {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        show('', false);
        root.querySelector('.sbl-ind__picker').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    show((window.location.hash || '').replace('#', ''), false);
    window.addEventListener('hashchange', () => show((window.location.hash || '').replace('#', ''), false));
  })();

  } catch(e) { console.error(e); }
})();
})();
